import { slice } from './slice'

const afaCartAdjustActions = {
  ...slice.actions,
}

export default afaCartAdjustActions
